// hooks/playground/useTemporaryRows.js
import { useState, useCallback } from 'react';

export const useTemporaryRows = (months, initialRows = {}) => {
  const [temporaryRows, setTemporaryRows] = useState(initialRows);
  const [editingTempName, setEditingTempName] = useState(null);

  // ✅ Function to load temporary rows from a scenario
  const loadTemporaryRows = useCallback((rows) => {    
    // Log each group for debugging
    Object.entries(rows || {}).forEach(([groupKey, groupRows]) => {
      console.log(`  Group "${groupKey}":`, groupRows.length, 'rows');
      groupRows.forEach(row => {
        console.log(`    - ${row.name} (${row.id})`);
      });
    });
    
    setTemporaryRows(rows || {});
  }, []);

  const addTemporaryRow = useCallback((groupKey) => {
    const newRow = {
      id: `temp-${Date.now()}`,
      name: 'New Line Item',
      groupKey,
      values: months.reduce((acc, month) => {
        acc[month.month_num] = 0;
        return acc;
      }, {})
    };

    console.log('➕ Adding temporary row to group:', groupKey);

    setTemporaryRows(prev => ({
      ...prev,
      [groupKey]: [...(prev[groupKey] || []), newRow]
    }));

    setTimeout(() => setEditingTempName(newRow.id), 0);
  }, [months]);

  const deleteTemporaryRow = useCallback((groupKey, rowId) => {    
    setTemporaryRows(prev => {
      const newRows = { ...prev };
      newRows[groupKey] = (newRows[groupKey] || []).filter(row => row.id !== rowId);
      
      if (newRows[groupKey].length === 0) {
        delete newRows[groupKey];
      }
      
      return newRows;
    });
  }, []);

  const updateTemporaryRowName = useCallback((groupKey, rowId, newName) => {
    setTemporaryRows(prev => {
      const newRows = { ...prev };
      const groupRows = newRows[groupKey] || [];
      const rowIndex = groupRows.findIndex(row => row.id === rowId);
      
      if (rowIndex !== -1) {
        newRows[groupKey] = [...groupRows];
        newRows[groupKey][rowIndex] = {
          ...groupRows[rowIndex],
          name: newName
        };
      }
      
      return newRows;
    });
  }, []);

  const updateTemporaryRowValue = useCallback((groupKey, rowId, monthNum, value) => {
    setTemporaryRows(prev => {
      const newRows = { ...prev };
      const groupRows = newRows[groupKey] || [];
      const rowIndex = groupRows.findIndex(row => row.id === rowId);
      
      if (rowIndex !== -1) {
        newRows[groupKey] = [...groupRows];
        newRows[groupKey][rowIndex] = {
          ...groupRows[rowIndex],
          values: {
            ...groupRows[rowIndex].values,
            [monthNum]: value
          }
        };
      }
      
      return newRows;
    });
  }, []);

  const resetTemporaryRows = useCallback(() => {
    setTemporaryRows({});
    setEditingTempName(null);
  }, []);

  return {
    temporaryRows,
    editingTempName,
    setEditingTempName,
    addTemporaryRow,
    deleteTemporaryRow,
    updateTemporaryRowName,
    updateTemporaryRowValue,
    resetTemporaryRows,
    loadTemporaryRows,
  };
};